import { useCallback, useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import { AccountModalSettings } from '~/contracts/common';
import useAddFavorite from './useAddFavoriteFlow';

const useFavoriteAndSubscribe = ({
  modalSettings = undefined,
  stockNumber,
  vehicleId
}: {
  modalSettings?: AccountModalSettings;
  stockNumber: number;
  vehicleId: number;
}) => {
  const { setReservableNotificationModalOpen } = useContext(ModalContext);
  const openReservableNotificationModal = useCallback(
    () => setReservableNotificationModalOpen(true, { isSubscribed: true }),
    [setReservableNotificationModalOpen]
  );
  const addFavorite = useAddFavorite({
    onAddFavorite: openReservableNotificationModal
  });

  return useCallback(() => {
    void addFavorite({
      modalSettings,
      stockNumber,
      subscribeToNotifications: true,
      vehicleId
    });
  }, [addFavorite, modalSettings, stockNumber, vehicleId]);
};

export default useFavoriteAndSubscribe;
